/**
 * Traduz erros técnicos (vazados do backend/IA) em mensagens claras pro usuário
 * leigo. Ex: "Respostas não contém JSON válido" vira algo que faz sentido.
 * Mantém a mensagem original quando ela já é curta e amigável em pt-BR.
 */
export function friendlyError(raw: string | null | undefined): string {
  const m = (raw ?? "").toLowerCase();
  if (!m.trim()) return "Algo deu errado. Tente de novo em instantes.";

  // Falha da IA ao interpretar o conteúdo (JSON inválido na resposta do modelo).
  if (m.includes("json"))
    return "A IA não conseguiu interpretar o conteúdo do arquivo. Tente de novo ou envie em outro formato (ex: um PDF com texto selecionável, não escaneado).";
  if (m.includes("timeout") || m.includes("timed out") || m.includes("abort"))
    return "A análise demorou demais e foi interrompida. Tente de novo.";
  if (m.includes("rate") || m.includes("429") || m.includes("too many"))
    return "Muitas requisições agora. Espere um instante e tente de novo.";
  if (m.includes("failed to fetch") || m.includes("network") || m.includes("conexão"))
    return "Sem conexão com o servidor. Verifique sua internet e tente de novo.";
  if (m.includes("unauthorized") || m.includes("api key") || m.includes("401") || m.includes("403"))
    return "Tivemos um problema de configuração no servidor. Avise o suporte.";
  if (m.includes("large") || m.includes("size") || m.includes("20mb") || m.includes("payload"))
    return "Arquivo grande demais. O limite é 20MB.";

  // Ainda parece técnico/inglês/stack? Dá um fallback amigável.
  if (/[{}<>]|exception|error:|stack|undefined|\bnull\b|parse|invalid/.test(m))
    return "Não consegui processar isso agora. Tente de novo ou use outro arquivo.";

  return raw!; // já é uma mensagem curta e amigável
}
